export enum PropertyTab {
    DETAILS = "details",
    ISSUES = "issues",
    SOLUTIONS = "solutions",
    TENDERING = "tendering"
}
